// Configuration du frontend, lue AU DÉMARRAGE et non au build : une même image Docker sert tous les
// environnements (dev, production) — governance/04_CI_CD_GOVERNANCE.md, « Pipeline cible ».
//   1. window.__ENV__ : public/env.js, réécrit par le conteneur à son démarrage (frontend/docker-entrypoint.sh)
//      à partir de BACKEND_URL et STRIPE_PUBLISHABLE_KEY ;
//   2. sinon les variables de build CRA (REACT_APP_*, frontend/.env) : développement local (craco start), Jest.
// Ne jamais lire process.env.REACT_APP_* ailleurs que dans ce fichier.
const runtime = (typeof window !== 'undefined' && window.__ENV__) || {};

export const BACKEND_URL = runtime.BACKEND_URL || process.env.REACT_APP_BACKEND_URL || '';
export const STRIPE_PUBLISHABLE_KEY = runtime.STRIPE_PUBLISHABLE_KEY || process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';
// Alertes d'erreur (T4) : clé PUBLIQUE du projet Sentry des écrans (DSN) ; vide = désactivé (local, CI)
export const SENTRY_DSN = runtime.SENTRY_DSN || process.env.REACT_APP_SENTRY_DSN || '';
export const ENVIRONMENT = runtime.ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT || 'dev';
